/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MarketFormData,
    MarketFormDataFromJSON,
    MarketFormDataToJSON,
    MarketFormValidationData,
    MarketFormValidationDataFromJSON,
    MarketFormValidationDataToJSON,
    MarketFormWarningsData,
    MarketFormWarningsDataFromJSON,
    MarketFormWarningsDataToJSON,
} from '../models';

export interface ApiMarketFormCreatePostRequest {
    marketFormData?: MarketFormData;
}

export interface ApiMarketFormDataGetRequest {
    id?: string;
}

export interface ApiMarketFormUpdatePostRequest {
    marketFormData?: MarketFormData;
}

export interface ApiMarketFormValidatePostRequest {
    create?: boolean;
    marketFormData?: MarketFormData;
}

export interface ApiMarketFormWarningsPostRequest {
    marketFormData?: MarketFormData;
}

/**
 * no description
 */
export class MarketFormApi extends runtime.BaseAPI {

    /**
     */
    async apiMarketFormCreatePostRaw(requestParameters: ApiMarketFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarketForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarketFormDataToJSON(requestParameters.marketFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMarketFormCreatePost(requestParameters: ApiMarketFormCreatePostRequest): Promise<void> {
        await this.apiMarketFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiMarketFormDataGetRaw(requestParameters: ApiMarketFormDataGetRequest): Promise<runtime.ApiResponse<MarketFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarketForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiMarketFormDataGet(requestParameters: ApiMarketFormDataGetRequest): Promise<MarketFormData> {
        const response = await this.apiMarketFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarketFormUpdatePostRaw(requestParameters: ApiMarketFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarketForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarketFormDataToJSON(requestParameters.marketFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMarketFormUpdatePost(requestParameters: ApiMarketFormUpdatePostRequest): Promise<void> {
        await this.apiMarketFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiMarketFormValidatePostRaw(requestParameters: ApiMarketFormValidatePostRequest): Promise<runtime.ApiResponse<MarketFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.create !== undefined) {
            queryParameters['create'] = requestParameters.create;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarketForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarketFormDataToJSON(requestParameters.marketFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiMarketFormValidatePost(requestParameters: ApiMarketFormValidatePostRequest): Promise<MarketFormValidationData> {
        const response = await this.apiMarketFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarketFormWarningsPostRaw(requestParameters: ApiMarketFormWarningsPostRequest): Promise<runtime.ApiResponse<MarketFormWarningsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarketForm/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarketFormDataToJSON(requestParameters.marketFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketFormWarningsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiMarketFormWarningsPost(requestParameters: ApiMarketFormWarningsPostRequest): Promise<MarketFormWarningsData> {
        const response = await this.apiMarketFormWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
